import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      gray_400: { main: gray400 } = {},
      gray_50: { main: gray50 } = {},
      gray_stroke: { main: grayStroke } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme
  return {
    formControl: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
      '& .MuiOutlinedInput-root.Mui-disabled': {
        opacity: 0.8 // Padronização da opacidade
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        padding: '0 0 0 4px !important',
        backgroundColor: isDark ? dark400 : gray50,
        '& .MuiOutlinedInput-input': {
          display: 'flex',
          alignItems: 'center',
          padding: '10px!important',
          backgroundColor: isDark ? dark400 : gray50,
          color: isDark ? dark50 : gray400,
          borderRadius: '8px',
          gap: '8px'
        }
      },
      '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
        {
          borderColor: isDark ? darkStroke : grayStroke
        },
      '&.small .MuiOutlinedInput-root .MuiOutlinedInput-input': {
        padding: '6px 10px!important', // Diminui o padding vertical
        fontSize: '0.875rem' // Opcional: diminui um pouco a fonte
      },
      '& .MuiButtonBase-root': {
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: 'transparent !important'
        }
      }
    },
    menuList: {
      overflow: 'auto',
      ...theme.scrollbarStyles,
      maxHeight: '300px !important',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    label: {
      color: isDark ? dark50 : gray400
    },
    iconChevronDown: {
      color: isDark ? dark50 : gray400
    },
    contactName: {
      color: isDark ? dark50 : gray400,
      fontWeight: 600,
      fontSize: '.875rem'
    },
    contactNumber: {
      color: isDark ? dark50 : gray400,
      fontSize: '.875rem'
    }
  }
})
